import React from 'react';
import propTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { SimpleModal } from '../../../../../../components/simple-modal';
import { messages } from './messages';
import styles from './styles.module.less';

export const WalletWarningModal = ({ onCloseWalletValidationWarning }) => {
  const history = useHistory();
  const redirect = () => {
    history.push('/settings/carriers?registerWallet');
  };

  return (
    <>
      <SimpleModal
        actionMessage={messages.okButton}
        cancelMessage={messages.cancel}
        className={styles.modal}
        headerMessage={messages.title}
        onAction={redirect}
        onCancel={onCloseWalletValidationWarning}
        onClose={onCloseWalletValidationWarning}
        size='custom'
      >
        <div className={styles['modal-body']}>
          <FormattedMessage {...messages.message} />
        </div>
      </SimpleModal>
    </>
  );
};

WalletWarningModal.propTypes = {
  onCloseWalletValidationWarning: propTypes.func.isRequired,
};
